module.exports = "/images/Slovenia.png?abc321f6815f4a24a6657c55ef81c83f";